// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__3vpfo","image2":"styles_image2__33AmS","mobileImage":"styles_mobileImage__1c0dA"};